import { useInteraction } from '@/hooks/useInteraction';
import styles from './TrashZone.module.css';

export function TrashZone() {
  const { trashRef } = useInteraction();
  return (
    <div
      ref={trashRef}
      className={`${styles.trash} trash-zone`}
      role="region"
      aria-label="Drop notes here to delete"
      data-drop-target="trash"
    >
      <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6h12z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
      <span className={styles.label}>Drop to delete</span>
    </div>
  );
}
